export default __webpack_public_path__ + "static/tim-c0632644920fc10f6aabcdc8bba828bb.jpg";